import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { Flex } from '../base/layout-components';
import { getColor } from 'common/constants/_colors';
import Notification from './index';

const TransitionWrapper = styled.div`
  :not(:last-child) {
    & > div > div {
      border-bottom: 1px solid ${getColor('silverSand')};
    }
  }

  &.item-enter {
    opacity: 0;
    transform: translateY(400px);
  }
  &.item-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: all 500ms ease-in-out;
  }
  &.item-exit {
    opacity: 1;
    transform: translateX(0);
  }
  &.item-exit-active {
    opacity: 0;
    transform: translateX(400px);
    transition: all 500ms ease-in-out;
  }
`;

const NotificationList = ({ notifications, onRemoveClick }) => {
  return (
    <Flex
      height='100%'
      width='100%'
      direction='column'
      style={{ overflowY: 'scroll', overflowX: 'hidden' }}
    >
      <TransitionGroup>
        {notifications.map(({ content, ...notification }) => (
          <CSSTransition
            key={notification.notificationId}
            timeout={500}
            classNames='item'
          >
            <TransitionWrapper width='100%' height='auto'>
              <Notification {...notification} onRemoveClick={onRemoveClick}>
                {content}
              </Notification>
            </TransitionWrapper>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Flex>
  );
};

NotificationList.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      ...Notification.propTypes,
      content: PropTypes.element
    })
  )
};

export default NotificationList;
